import React, { Component } from "react";

import FadeInSection from "../FadeIn/FadeIn";

import "./Banner.css";

class banner extends Component {
  componentDidMount() {
    window.addEventListener("scroll", this.detectScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.detectScroll);
  }

  handleScroll = () => {
    const headerImg = document.getElementsByClassName("bannerImg")[0];
    const d = window.scrollY / 2;
    headerImg.style.transform = `translateY(${d}px)`;
  };
  detectScroll = (e) => {
    requestAnimationFrame(this.handleScroll);
  };

  render() {
    let classes = "Banner";
    if (this.props.full) {
      classes += " full";
    }
    return (
      <div className={classes}>
        <img
          className="bannerImg"
          src={this.props.img_src}
          alt={this.props.img_alt}
        />
        <div className="bannerContent">
          <FadeInSection direction="top">{this.props.children}</FadeInSection>
        </div>

        {/* <div className="bannerMask"></div> */}
      </div>
    );
  }
}

export default banner;
